import { render, staticRenderFns } from "./PlanCardSimple.vue?vue&type=template&id=13965faa&scoped=true&"
import script from "./PlanCardSimple.vue?vue&type=script&lang=ts&"
export * from "./PlanCardSimple.vue?vue&type=script&lang=ts&"
import style0 from "./PlanCardSimple.vue?vue&type=style&index=0&id=13965faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13965faa",
  null
  
)

export default component.exports